import { useEffect } from 'react';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
import { usePurchaseableProductsForApiName } from '../../../hooks/useBulkPurchaseOptions';
import { usePurchaseOptionsForProducts } from '../../../hooks/usePurchaseOptions';
import { trackTermSelectorInteraction } from '../../../utils/tracking/trackingEventUtils';
import SkeletonLoadWrapper from '../loading/SkeletonLoadWrapper';
import { BaseTermSelectorComponent, getDiscountPercentageToShow } from './BaseTermSelectorComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const DetailedTermSelector = ({
  productConfigurations = [],
  apiName,
  onChange,
  trackingSource,
  activeTerm,
  screen
}) => {
  var _availableTerms$, _availableTerms$2, _availableTerms$3, _availableTerms$4;
  const {
    loading,
    purchaseOptions: purchaseOptionsForProducts
  } = usePurchaseOptionsForProducts({
    productConfigurations
  });
  const {
    purchaseOptionsForApiName
  } = usePurchaseableProductsForApiName({
    apiName
  });
  const purchaseOptions = (productConfigurations === null || productConfigurations === void 0 ? void 0 : productConfigurations.length) > 0 ? purchaseOptionsForProducts : apiName ? purchaseOptionsForApiName : [];
  const availableTerms = purchaseOptions === null || purchaseOptions === void 0 ? void 0 : purchaseOptions.map(option => {
    return option.offerInfo;
  });
  const annualDiscountPercent = (!(availableTerms !== null && availableTerms !== void 0 && availableTerms.length) ? 0 : ((_availableTerms$ = availableTerms[0]) === null || _availableTerms$ === void 0 ? void 0 : _availableTerms$.discount) === 0 ? (_availableTerms$2 = availableTerms[1]) === null || _availableTerms$2 === void 0 ? void 0 : _availableTerms$2.discount : getDiscountPercentageToShow((_availableTerms$3 = availableTerms[1]) === null || _availableTerms$3 === void 0 ? void 0 : _availableTerms$3.discount, (_availableTerms$4 = availableTerms[0]) === null || _availableTerms$4 === void 0 ? void 0 : _availableTerms$4.discount)) || 0;
  const hasAnnualDiscount = annualDiscountPercent > 0;
  const discountMessage = `${Math.round(annualDiscountPercent)}PercentDiscount`;
  useEffect(() => {
    const availableTerm = availableTerms ? activeTerm === MONTHLY ? availableTerms[1] : availableTerms[0] : null;
    trackTermSelectorInteraction({
      action: 'view',
      term: activeTerm,
      paymentTerm: availableTerm === null || availableTerm === void 0 ? void 0 : availableTerm.payment,
      commitTerm: availableTerm === null || availableTerm === void 0 ? void 0 : availableTerm.commitment,
      trackingSource,
      discountShown: discountMessage,
      screen,
      productNames: apiName ? [apiName] : []
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // couldn't find a purchase option or there is only one term available
  if (!purchaseOptions || !availableTerms || (availableTerms === null || availableTerms === void 0 ? void 0 : availableTerms.length) < 2) {
    return null;
  }
  const onToggleChange = () => {
    const newQueryParamTerm = activeTerm === MONTHLY ? ANNUAL : MONTHLY;
    onChange(newQueryParamTerm);
    const availableTerm = newQueryParamTerm === MONTHLY ? availableTerms[1] : availableTerms[0];
    trackTermSelectorInteraction({
      action: 'click',
      term: newQueryParamTerm,
      paymentTerm: availableTerm.payment,
      commitTerm: availableTerm.commitment,
      trackingSource,
      discountShown: discountMessage,
      screen,
      productNames: []
    });
  };
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    children: /*#__PURE__*/_jsx(BaseTermSelectorComponent, {
      onToggleChange: onToggleChange,
      trackingSource: trackingSource,
      activeTerm: activeTerm,
      availableTerms: availableTerms,
      hasAnnualDiscount: hasAnnualDiscount
    })
  });
};
export default DetailedTermSelector;